import { Dialog, DialogContent, Box, Typography, Button, IconButton, Link } from "@mui/material"
import { Close } from "@mui/icons-material"

const ModalMandado = ({ openModalMandado, setOpenModalMandado, mandadoDados }) => {
    const handleClose = () => {
        setOpenModalMandado(false)
    }

    // Pegar o primeiro item do array ou o objeto direto
    const mandado = Array.isArray(mandadoDados) && mandadoDados.length > 0
        ? mandadoDados[0]
        : mandadoDados || {}

    const nome = mandado.nome || ''
    const instituicao = mandado.fonte || ''
    const estado = mandado.estado || ''
    const status = mandado.status || ''
    const dtCriacao = mandado.dt_criacao || ''
    const dtUltAtualizacao = mandado.dt_ult_att || ''

    return (
        <Dialog
            open={openModalMandado}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '8px',
                    overflow: 'hidden'
                }
            }}
        >
            {/* Header Vermelho */}
            <Box
                sx={{
                    backgroundColor: '#d32f2f',
                    color: 'white',
                    padding: '12px 16px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderRadius: '8px 8px 0 0'
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 'bold',
                        fontSize: '18px'
                    }}
                >
                    Atenção !
                </Typography>
                <IconButton
                    onClick={handleClose}
                    sx={{
                        color: 'white',
                        padding: '4px',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)'
                        }
                    }}
                >
                    <Close />
                </IconButton>
            </Box>

            {/* Corpo Branco */}
            <DialogContent
                sx={{
                    backgroundColor: 'white',
                    padding: '20px',
                    color: 'black'
                }}
            >
                <Box sx={{ marginBottom: '16px' }}>
                    <Typography
                        sx={{
                            fontSize: '15px',
                            color: 'black',
                            marginBottom: '12px',
                            lineHeight: '1.5'
                        }}
                    >
                        O nome <strong>{nome}</strong> possui mandado no Banco Nacional de Mandados de Prisão. Favor, validar a informação no site oficial do governo:{' '}
                        <Link
                            href="https://portalbnmp.cnj.jus.br/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: '#1976d2',
                                textDecoration: 'underline',
                                '&:hover': {
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            https://portalbnmp.cnj.jus.br/
                        </Link>
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <Typography sx={{ fontSize: '15px', color: 'black' }}>
                        <strong>Instituição:</strong> {instituicao}
                    </Typography>
                    {estado && (
                        <Typography sx={{ fontSize: '15px', color: 'black' }}>
                            <strong>Estado:</strong> {estado}
                        </Typography>
                    )}
                    <Typography sx={{ fontSize: '15px', color: 'black' }}>
                        <strong>Status:</strong> {status}
                    </Typography>
                    {dtCriacao && (
                        <Typography sx={{ fontSize: '15px', color: 'black' }}>
                            <strong>Dt. Criação:</strong> {dtCriacao}
                        </Typography>
                    )}
                    {dtUltAtualizacao && (
                        <Typography sx={{ fontSize: '15px', color: 'black' }}>
                            <strong>Dt. Última atualização:</strong> {dtUltAtualizacao}
                        </Typography>
                    )}
                </Box>
            </DialogContent>

            {/* Footer com Botão Voltar */}
            <Box
                sx={{
                    padding: '12px 20px',
                    backgroundColor: 'white',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    borderTop: '1px solid #e0e0e0'
                }}
            >
                <Button
                    onClick={handleClose}
                    variant="contained"
                    sx={{
                        backgroundColor: '#4caf50',
                        color: 'white',
                        fontWeight: 'bold',
                        padding: '8px 24px',
                        borderRadius: '4px',
                        textTransform: 'none',
                        '&:hover': {
                            backgroundColor: '#45a049'
                        }
                    }}
                >
                    Voltar
                </Button>
            </Box>
        </Dialog>
    )
}

export default ModalMandado
